import * as yup from "yup";
export const ManageWageAccountValidationSchema = yup.object({});
